require(93);
var Iterators = require(64);
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;